export default {"src":"/_next/static/image/public/images/ic_map-gps.d5a9c9bbab9689183b642fc12348ba68.svg","height":62,"width":62};